import { NgModule } from "@angular/core";
import { TransportStatsComponent } from "./TransportStatsComponent/transportStats.component";
// import {NgxRruleModule} from 'ngx-rrule';
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSpinner,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatHint,
    MatSortModule,
    MatRadioModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatOptionModule,
    MatDatepickerModule,
} from "@angular/material";
import { FormsModule } from "@angular/forms";
import { RevenueService } from "../services/revenue.service";
import { ProductCategoryService } from "../services/product-category.service";
import { PrintService } from "../services/print.service";
import { CommonModule } from "@angular/common";
import {TransportStatsService} from '../services/transport-stats.service';
import {TransportComponent} from './TransportComponent/transport.component';
import {AppRouterModule} from '../routers/app-router.module';
import {MomentModule} from 'angular2-moment';
import {TransportRepeatComponent} from './TransportRepeatComponent/transportRepeat.component';
import {TransportRepeatDialogComponent} from './TransportRepeatDialogComponent/transportRepeat.dialog.component';
import {RepeatTransportService} from '../services/repeat-transport.service';
import {CompleteTransportDialogComponent} from './CompleteTransportDialogComponent/completeTransport.dialog.component';
import {CompleteTransportCancelConfirmDialogComponent} from './CompleteTransportCancelConfirmDialogComponent/complete-transport-cancel-confirm.dialog.component';
import {ContractStateComponent} from '../SharedModule/ContractStateComponent/contract-state.component';
import {SharedModule} from '../SharedModule/shared.module';
import {TransportAgendaComponent} from './TransportAgendaComponent/transportAgenda.component';
import {DirectivesModule} from '../directives/directives.module';

@NgModule({
    declarations: [
        TransportComponent,
        TransportStatsComponent,
        TransportRepeatComponent,
        TransportRepeatDialogComponent,
        CompleteTransportDialogComponent,
        CompleteTransportCancelConfirmDialogComponent,
        TransportAgendaComponent,
    ],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatOptionModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatDatepickerModule,
        FormsModule,
        AppRouterModule,
        MomentModule,
        MatTooltipModule,
        MatSlideToggleModule,
        SharedModule,
        DirectivesModule
        // NgxRruleModule,
    ],
    entryComponents: [
        TransportRepeatDialogComponent,
        ContractStateComponent,
        CompleteTransportDialogComponent,
        CompleteTransportCancelConfirmDialogComponent,
    ],
    exports: [TransportStatsComponent],
    providers: [
        TransportStatsService,
        RepeatTransportService,
    ],
})
export class TransportModule {}



// WEBPACK FOOTER //
// /app/src/TransportModule/transport.module.ts